<template>
  <va-modal
    id="requestComentFormModal"
    ref="requestComentFormModal"
    :value="isOpen"
    :size="'medium'"
    :noOutsideDismiss="true"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    @ok="submit"
    @cancel="onCancel">

    <div slot="header" class="modal-title">
      <span>{{ $t('evocall.requests.actions.add_comment') }}</span>
    </div>

    <form class="evollu-form">
      <div class="row">
        <div class="col-12">
          <va-input
            v-model="obs"
            :label="$t('agenda.inputs.observations')"
            type="textarea"
            :minRows="3"
            :maxRows="8" />
        </div>
      </div>
    </form>
  </va-modal>
</template>
<script>
import { RequestService } from '@/api/EvocallService'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      obs: this.request.obs || '',
      isOpen: false
    }
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    submit: function () {
      RequestService.updateObservations(this.request.id, { obs: this.obs })
        .then(request => {
          this.showToast(this.$t('evocall.requests.actions.observations_updated'), this.$store.state.successToastOptions)
          this.$emit('observations-updated', { request })
        }).catch(errors => {
          console.log(errors)
          this.showToast(this.$t('evocall.requests.actions.observations_update_failed'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.onCancel()
        })
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modal-closed')
      }, 500)
    }
  }
}
</script>
